export default "__VITE_ASSET__ZuzOsBC$__"